export const API_END_POINT = process.env.REACT_APP_API_BASE;
export const API_FILE_DOWNLOAD_POINT = "https://gr-api.ingencorp.in/";
export const API_BASE_URL = process.env.REACT_APP_BASE_URL;

export const DEFAULT_DATE_FORMAT = "DD MMM YYYY";

// do not change roles position and name
export const MAIN_ROLES = [
    "System Admin",
    "Admin"
];

// do not change roles position and name
export const PUBLIC_URL = [
    "View Portfolio",
    "My Work",
    "Projects",
    "Action Tracker"
];

export const PROCUREMENT_TABS_CONFIG = {
    default: {
        user: [
            { label: "Sitc", value: "Procurement Plan - Sitc" },
            { label: "Dp Items", value: "Procurement Plan - Dp Items" },
            { label: "Hotel Sitc", value: "Procurement Plan - Hotel Sitc" },
            { label: "Hotel - Bought Out Items", value: "Hotel - Bought Out Items" },
            { label: "Plan - Soft Cost", value: "Procurement Plan - Soft Cost" },
        ],
        admin: [
            { label: "Sitc", value: "Procurement Plan - Sitc" },
            { label: "Dp Items", value: "Procurement Plan - Dp Items" },
            { label: "Hotel Sitc", value: "Procurement Plan - Hotel Sitc" },
            { label: "Hotel - Bought Out Items", value: "Hotel - Bought Out Items" },
            { label: "Soft Cost", value: "Procurement Plan - Soft Cost" },
            { label: "Cancelled-Items", value: "Cancelled-Items" },
        ]
    },

    "61bf1905-4332-4994-8e0a-f0c6002f701e": {
        user: [
            { label: "Sitc", value: "Procurement Plan - Sitc" },
            { label: "Soft Cost", value: "Procurement Plan - Soft Cost" },
        ],
        admin: [
            { label: "Sitc", value: "Procurement Plan - Sitc" },
            { label: "Soft Cost", value: "Procurement Plan - Soft Cost" },
            { label: "Cancelled-Items", value: "Cancelled-Items" },
        ]
    }
};
export const PROCUREMENT_SUB_TABS_CONFIG = {
    default: {
        normal: [
            { label: "Summary", value: "summary" },
            { label: "Detail", value: "detail" },
        ],
        cancelled: [
            { label: "Sitc", value: "Procurement Plan - Sitc" },
            { label: "Dp Items", value: "Procurement Plan - Dp Items" },
            { label: "Hotel Sitc", value: "Procurement Plan - Hotel Sitc" },
            { label: "Hotel - Bought Out Items", value: "Hotel - Bought Out Items" },
            { label: "Soft Cost", value: "Procurement Plan - Soft Cost" },
        ]
    },
    "61bf1905-4332-4994-8e0a-f0c6002f701e": {
        normal: [
            { label: "Summary", value: "summary" },
            { label: "Detail", value: "detail" },
        ],
        cancelled: [
            { label: "Sitc", value: "Procurement Plan - Sitc" },
            { label: "Soft Cost", value: "Procurement Plan - Soft Cost" },
        ]
    }
};


export const PROCUREMENT_TYPES = {
    default: [
        { label: "SITC", value: "SITC" },
        { label: "DP Items", value: "DPI" },
        { label: "Hotel SITC", value: "HOTEL_SITC" },
        { label: "Bought Out Items", value: "BOI" },
        { label: "Soft Cost", value: "Soft Cost" }
    ],
    "61bf1905-4332-4994-8e0a-f0c6002f701e": [
        { label: "SITC", value: "SITC" },
        { label: "Soft Cost", value: "Soft Cost" }
    ]

};

export const ALLOW_SAFEXPRESS_DASHBOARD = [
    "sudeep@fourmativ.in",
    "dipesh.g@fourmativ.in",
    "vijaypandurang.z@fourmativ.in",
    "pushpendra.c@fourmativ.in",
    "shruti.k@fourmativ.in",
    "aruni.sharma@pwc.com",
    "akumar@ingencorp.in",
    "dbhardwa@ingencorp.in",
    "Rajat.x.agrawal@pwc.com",
    "lkunwar@ingencorp.in"
];

// Add future customer dashboards here. projectIds is optional; omitting it makes
// the dashboard available on any project for users in allowedEmails.
export const CUSTOMER_DASHBOARDS = [
    {
        key: "safexpress",
        label: "Safexpress",
        path: "safexpressdashboard",
        allowedEmails: ALLOW_SAFEXPRESS_DASHBOARD,
    },
];

export const PROCUREMENT_DASHBOARD_CONFIG = {
    default: {
        showServices: true,
        showBoi: true,
    },

    "61bf1905-4332-4994-8e0a-f0c6002f701e": {
        showServices: true,
        showBoi: false,
    }
};

export const FINANCIALBG_TABS_CONFIG = [
    { label: "ABG", value: 0 },
    { label: "PBG", value: 1 },
    { label: "RBG", value: 2 },
];

export const FINANCIALBG_TYPES = [
    { label: "ABG", value: "ABG" },
    { label: "PBG", value: "PBG" },
    { label: "RBG", value: "RBG" },
];
